module.exports = __webpack_public_path__ + "static/media/liwenhan.ce05e8d6.png";